import React, { FC, useMemo } from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles({
  label: {
    padding: '.5em',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: '.8em',
    borderRight: '1px solid rgba(0,0,0,0.2)'
  },
  value: {
    padding: '0 1em',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: '.7em'
  },
  valueInner: {
    width: '100%',
    padding: '.4em 0',
    display: 'flex',
    alignItems: 'center'
  },
  row: {
    borderBottom: '1px solid rgba(0,0,0,0.2)'
  },
  lastRow: {
    borderBottom: 'none'
  },
  optionsRow: {
    padding: '.5em',
    borderBottom: '1px solid rgba(0,0,0,0.2)',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    background: '#fafafa'
  }
});

interface Props {
  index: number;
  rows: string[];
  renderMap: { [key: string]: React.ReactNode };
  optionsRow?: React.ReactNode;
}

export const MobileTable: FC<Props> = ({
  index,
  rows,
  renderMap,
  optionsRow
}) => {
  const classes = useStyles();
  const isEven = useMemo(() => (index & 1) === 0, [index]);

  return (
    <Grid
      container
      style={{ border: '1px solid rgba(0,0,0,0.4)', marginBottom: 5 }}
    >
      {/*ROW FOR OPTIONS */}
      {optionsRow && (
        <Grid item xs={12} className={classes.optionsRow}>
          {optionsRow}
        </Grid>
      )}

      {rows.map((name, i) => {
        const isLast = i === rows.length - 1;

        return (
          <Grid
            item
            container
            xs={12}
            key={name}
            className={isLast ? classes.lastRow : classes.row}
          >
            <Grid item xs={3} className={classes.label}>
              <Typography> {name}</Typography>
            </Grid>

            <Grid
              item
              xs
              className={classes.value}
              style={{ background: !isEven ? 'white' : '#F5F5F5' }}
            >
              <div className={classes.valueInner}>
                {renderMap[name] ?? null}
              </div>
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};
